import { useEffect } from 'react';
const useFormValueUpdate = ({ name, enteredValue, previousEnteredValue, hasEnteredValueChanged, handleFetchSuggestions, setValue, maxLength = 100, shouldValidate }) => {
    useEffect(() => {
        /** we want to avoid validation on mount when previousEnteredValue is undefined */
        /** but validate on any other change, including when the field is cleared (equals '') */
        if (hasEnteredValueChanged && previousEnteredValue !== undefined) {
            setValue(name, enteredValue, { shouldValidate, shouldDirty: true });
            if (enteredValue.length <= maxLength) {
                handleFetchSuggestions && handleFetchSuggestions(enteredValue);
            }
        }
    }, [
        setValue,
        name,
        enteredValue,
        handleFetchSuggestions,
        hasEnteredValueChanged,
        previousEnteredValue,
        maxLength,
        shouldValidate
    ]);
};
export default useFormValueUpdate;
//# sourceMappingURL=useFormValueUpdate.js.map